import createRoute from '@widesk-ui/tools/createRoute';
import UserModel   from '@models/account/UserModel';

export default createRoute.table('/users', 'account', 'UserTable', UserModel.localize('plural'));